import React, { useState, useMemo } from "react";
import { Button } from "../../../../../components/RegularComponents";
import { humanReadableDate } from "../../../../../app/utils";
import { ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY } from "../../InformationDetailPanel";

const headers = [
  {
    key: "note",
    title: "Description",
    width: "40%",
    sort: (isAscending) => (a, b) => {
      const aStr = a.note;
      const bStr = b.note;
      return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr);
    }
  },
  {
    key: "createdDate",
    title: "Date",
    width: "20%",
    sort: (isAscending) => (a, b) => {
      const aStr = `${a.createdDate}`;
      const bStr = `${b.createdDate}`;
      return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr);
    },
    format: (dateValue) => {
      return humanReadableDate(dateValue);
    }
  },
  {
    key: "createdBy",
    title: "Created By",
    width: "40%",
    sort: (isAscending) => (a, b) => {
      const aStr = `${a.createdBy}`;
      const bStr = `${b.createdBy}`;
      return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr);
    }
  }
];

const PenaltiesDescriptionTable = (props) => {
  const { appData, setDetails } = props;

  const [sortingParameters, setSortingParameters] = useState({});

  const rows = useMemo(() => {
    if (!appData?.internalNoteList) {
      return [];
    }

    const notes = appData?.internalNoteList?.filter(
      (note) => note.internalNoteCategory === ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY
    );
    const header = headers.find((h) => h.key === sortingParameters.key);
    if (!header) {
      return notes;
    }

    const newInternalNotes = [...notes];
    newInternalNotes.sort(header.sort(sortingParameters.isAscending));
    return newInternalNotes;
  }, [sortingParameters, appData?.internalNoteList]);

  const getSortIcon = (header) => {
    if (header.key !== sortingParameters?.key) {
      return <i style={{ color: "lightgray" }} className={`fa fa-2x fa-sort`} />;
    }
    const activeClass = header.key === sortingParameters?.key ? "active" : "";
    const activeStyle = header.key === sortingParameters?.key ? "#0058a4" : "lightgray";
    const iconStr = sortingParameters?.isAscending ? "fa-sort-asc" : "fa-sort-desc";
    return <i style={{ color: activeStyle }} className={`fa fa-2x ${activeClass} ${iconStr}`} />;
  };

  const headerClicked = (header) => () => {
    let modifiedSortingParams = { ...sortingParameters };

    if (header.key === modifiedSortingParams.key) {
      modifiedSortingParams.isAscending = !modifiedSortingParams.isAscending;
    } else {
      modifiedSortingParams = { key: header.key, isAscending: false };
    }

    setSortingParameters(modifiedSortingParams);
  };

  if (!rows?.length) {
    return null;
  }

  return (
    <div style={{ marginTop: "1.5em" }}>
      <table>
        <thead>
          <tr>
            {headers.map((h) => (
              <th key={h.key} onClick={headerClicked(h)}>
                <div
                  style={{
                    display: "inline-flex",
                    width: "100%",
                    gap: "0.5rem",
                    alignItems: "center",
                    cursor: "arrow"
                  }}
                >
                  <span>{h.title}</span>
                  <span style={{ marginRight: "6px" }}>{getSortIcon(h)}</span>
                </div>
              </th>
            ))}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              {headers.map((header, headerIndex) => {
                const key = header.key;
                const value = row[key];
                const formattedValue = header.format ? header.format(value) : value;
                return (
                  <td key={headerIndex} style={{ width: header.width }}>
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "100%",
                        maxWidth: "250px"
                      }}
                    >
                      {formattedValue}
                    </div>
                  </td>
                );
              })}
              <td>
                <Button
                  id={`licence-suspension-detail-${index}`}
                  className={"licence-queue-review-readonly-button"}
                  buttonType="regular_primary"
                  text="Details"
                  onClick={() => {
                    setDetails(row);
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PenaltiesDescriptionTable;
